import * as angular from "angular";

function filePrinter($timeout) {
  return function (fileData, fileName, contentType) {
    const blob = new Blob([fileData], {type: contentType});
    const blobURL = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);

    iframe.style.display = 'none';
    iframe.src = blobURL;
    iframe.onload = () => {

      $timeout(0).then(() => {
        iframe.focus();
        iframe.contentWindow.print();
      })
    };
  }
}

angular
  .module('bringoz.admin.commons')
  .service('filePrinter', filePrinter);
